import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { BatchEditService } from '../../services/batch-edit-service/batch-edit-service';
import { BaseModalModule } from '../base-modal.module';
import { BatchEditModalComponent } from './batch-edit-modal.component';
import { BatchEditModalInputComponent } from './input/batch-edit-modal-input.component';

@NgModule({
  declarations: [BatchEditModalComponent, BatchEditModalInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatFormFieldModule,
    MatOptionModule,
    FormsModule,
    MatSelectModule,
    MatRadioModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatDialogModule,
    BaseModalModule,
  ],
  exports: [BatchEditModalComponent, BatchEditModalInputComponent],
  providers: [BatchEditService],
  entryComponents: [BatchEditModalComponent, BatchEditModalInputComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BatchEditModule {}
